import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'CID';

export default createListReducer(TEMPLATE_NAME);
